module.exports = __webpack_public_path__ + "img/shield-plus.ef3abfcb.svg";